import { QueryManagement } from 'pages/queries';
import { useCanView } from 'hooks/useCanView';
import { useIsTokenExpired } from 'hooks/useIsTokenExpired';
import { Unauthorized } from 'components/unauthorized';
import { TokenExpired } from 'components/tokenExpired';

export const QueryManagementRoute = () => {
  const { canView } = useCanView('queries');
  const isExpired = useIsTokenExpired();

  return isExpired ? <TokenExpired /> : canView ? <QueryManagement /> : <Unauthorized />;
};
